module.exports = __webpack_public_path__ + "img/juliano.765f035a.png";